/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */
import AdvertisementList from './AdvertisementList';

/**
 * AdvertisementList module exports
 */
export { AdvertisementList as default };



// WEBPACK FOOTER //
// ./src/js/AdvertisementList/index.js